import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";

import Company from "./Company.jsx";
import PreLoader from "../components/helpersUI/loading/PreLoader.jsx";
import PageNotFound from "./PageNotFound.jsx";

// Este componente actuará antes de cualquier otro renderizado
const RouteInterceptor = ({ children }) => {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  const routesToRedirect = [
    "Agendamiento",
    "agendamiento",
    "Agendamiento/mobile",
    "agendamiento/mobile",
    "payment",
    "Payment",
    "Notify",
    "notify",
    "Acceso_Atencion",
    "acceso_atencion",
    "Acceso_Consentimiento",
    "acceso_consentimiento",
    "Acceso_Invitado",
    "acceso_invitado",
    "Terms",
    "terms",
    "Rights",
    "rights",
  ];

  if (
    (pathParts.length > 0 &&
      routesToRedirect.includes(pathParts[0]) &&
      (!pathParts.includes("medivalecu") || !pathParts.includes("medivalecu"))) ||
    pathParts.length === 0
  ) {
    const newPath = `/medivalecu/${pathParts.join("/")}`;
    return <Redirect to={newPath} />;
  }

  return children;
};

export function AppRouter() {
  return (
    <Router>
      <Suspense fallback={<PreLoader />}>
        <RouteInterceptor>
          <Switch>
            <Route
              exact
              path="/:company/:route?/:subroute?/:id?"
              component={Company}
            />
            <Route
              path="/404"
              render={() => {
                return (
                  <Suspense
                    fallback={
                      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-saluta-s to-saluta-c">
                        <PreLoader
                          text={"Cargando"}
                          classText="text-white font-bold z-100"
                          opacity={50}
                          isLoading={true}
                        />
                      </div>
                    }
                  >
                    <PageNotFound />
                  </Suspense>
                );
              }}
            />
            <Redirect to="/404" />
          </Switch>
        </RouteInterceptor>
      </Suspense>
    </Router>
  );
}
